import React from 'react';

const PoliticaPrivacidade: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-slate-900 py-12 px-4">
      <div className="max-w-3xl mx-auto bg-white dark:bg-slate-800 rounded-lg shadow-md p-8 md:p-12">
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-2">Politica de Privacidade</h1>
        <p className="text-sm text-gray-500 dark:text-gray-400 mb-8">Ultima atualizacao: 15 de julho de 2026</p>

        <div className="prose prose-gray dark:prose-invert max-w-none space-y-6 text-gray-700 dark:text-gray-300">

          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">1. Introducao</h2>
            <p>
              A SinTicket ("nos", "nosso", "plataforma") opera o sistema de gestao de atendimento omnichannel
              disponivel em sinticket.com.br. Esta Politica de Privacidade descreve como coletamos, usamos,
              armazenamos e protegemos dados pessoais em conformidade com a Lei Geral de Protecao de Dados
              (LGPD - Lei 13.709/2018), o Regulamento Geral de Protecao de Dados (GDPR) e as politicas
              da Meta Platforms.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">2. Controlador e Encarregado de Dados</h2>
            <p>
              <strong>Controlador de Dados:</strong> SinTicket, CNPJ 59.174.106/0001-54, Brasil.<br />
              <strong>Encarregado (DPO):</strong> Aparecido Moraes, email: suporte@sinticket.com.br, telefone: (19) 99975-3999.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">3. Dados Pessoais Coletados</h2>
            <p>Coletamos os seguintes tipos de dados pessoais:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Dados de cadastro:</strong> nome, email, senha (armazenada em hash), cargo/role.</li>
              <li><strong>Dados da empresa (tenant):</strong> nome da empresa, dominio, configuracoes.</li>
              <li><strong>Dados de contatos:</strong> nomes, numeros de telefone, enderecos de email dos contatos dos clientes das empresas usuarias.</li>
              <li><strong>Dados de mensagens:</strong> conteudo de mensagens trocadas via WhatsApp e outros canais integrados.</li>
              <li><strong>Dados de uso:</strong> logs de acesso, enderecos IP, timestamps de acoes, informacoes do navegador/dispositivo.</li>
              <li><strong>Dados de pagamentos:</strong> processados por parceiros de pagamento. Nos nao armazenamos dados de cartao de credito.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">4. Finalidades e Bases Legais</h2>
            <p>Processamos dados pessoais com base nas seguintes finalidades e bases legais:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Prestacao do servico (execucao de contrato):</strong> fornecimento, operacao e manutencao da plataforma.</li>
              <li><strong>Autenticacao e seguranca (interesse legitimo):</strong> verificacao de identidade, prevencao de fraude, protecao contra acessos nao autorizados.</li>
              <li><strong>Comunicacao (interesse legitimo):</strong> envio de notificacoes sobre o servico, atualizacoes e alertas de seguranca.</li>
              <li><strong>Marketing (consentimento):</strong> envio de comunicacoes promocionais e newsletters, mediante opt-in explicito.</li>
              <li><strong>Cumprimento legal (obrigacao legal):</strong> atendimento a requisitos legais, regulatórios ou judiciais.</li>
              <li><strong>Melhoria do servico (interesse legitimo):</strong> analise estatica de uso, desenvolvimento de novas funcionalidades.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">5. Compartilhamento de Dados</h2>
            <p>Seus dados pessoais podem ser compartilhados com:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Meta Platforms / WhatsApp:</strong> para envio e recebimento de mensagens via WhatsApp Business API. A Meta atua como Processador de dados sob os termos do WhatsApp Business Data Processing Terms.</li>
              <li><strong>Provedores de infraestrutura:</strong> servidores cloud utilizados para hospedagem e operacao da plataforma.</li>
              <li><strong>Autoridades competentes:</strong> quando exigido por lei, ordem judicial ou requisito de autoridade publica.</li>
            </ul>
            <p>Nao vendemos nem alugamos dados pessoais a terceiros para fins de marketing.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">6. Retencao de Dados</h2>
            <p>
              Os dados pessoais sao mantidos pelo tempo necessario para cumprir as finalidades para as quais
              foram coletados, salvo quando exigido ou permitido por lei. especificamente:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Dados de conta:</strong> mantidos durante a vigencia da conta e por ate 6 meses apos a exclusao.</li>
              <li><strong>Dados de mensagens:</strong> mantidos conforme politica de retencao configuravel pela empresa usuaria, com maximo de 12 meses.</li>
              <li><strong>Logs de acesso:</strong> mantidos por ate 12 meses para fins de seguranca e auditoria.</li>
              <li><strong>Dados de consentimento:</strong> mantidos por ate 5 anos apos a ultima interacao, para comprovacao de conformidade.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">7. Seus Direitos (LGPD Art. 18)</h2>
            <p>Voce tem o direito de:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Confirmacao</strong> da existencia de tratamento de dados.</li>
              <li><strong>Acesso</strong> aos seus dados pessoais.</li>
              <li><strong>Correcao</strong> de dados incompletos, inexatos ou desatualizados.</li>
              <li><strong>Anonimizacao, bloqueio ou eliminacao</strong> de dados desnecessarios, excessivos ou nao conformes.</li>
              <li><strong>Portabilidade</strong> dos dados a outro provedor de servico.</li>
              <li><strong>Eliminacao</strong> dos dados tratados com base no consentimento.</li>
              <li><strong>Informacao</strong> sobre compartilhamento de dados com terceiros.</li>
              <li><strong>Revogacao do consentimento</strong> a qualquer momento.</li>
            </ul>
            <p>
              Para exercer seus direitos, entre em contato com nosso DPO em suporte@sinticket.com.br ou
              utilize a funcionalidade de "Meus Dados" disponivel nas configuracoes da plataforma.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">8. Seguranca dos Dados</h2>
            <p>Implementamos medidas tecnicas e organizacionais para proteger seus dados:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Criptografia de dados em transito (TLS/HTTPS) e em repouso.</li>
              <li>Controle de acesso baseado em roles (RBAC) e autenticacao JWT.</li>
              <li>Logs de auditoria para rastreamento de acessos.</li>
              <li>Monitoramento continuo e atualizacoes de seguranca.</li>
              <li>Backup automatizado com criptografia.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">9. Transferencia Internacional de Dados</h2>
            <p>
              Alguns dos nossos provedores de infraestrutura podem operar fora do Brasil. Quando ha
              transferencia internacional de dados, garantimos que ela ocorra em conformidade com a
              LGPD, utilizando clausulas contratuais padrao ou其它 mecanismos adequados de protecao.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">10. Cookies</h2>
            <p>
              Utilizamos cookies essenciais para o funcionamento da plataforma (autenticacao, sessao,
              preferencias). Cookies nao essenciais sao utilizados apenas com seu consentimento previo.
              Consulte nossa Politica de Cookies para mais detalhes.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">11. Menores de Idade</h2>
            <p>
              Nossa plataforma nao e direcionada a menores de 18 anos. Nao coletamos intencionalmente
              dados pessoais de menores de idade. Se tomarmos conhecimento de que coletamos dados de
              um menor, tomaremos medidas para eliminar essas informacoes.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">12. Alteracoes nesta Politica</h2>
            <p>
              Podemos atualizar esta Politica de Privacidade periodicamente. Notificaremos os usuarios
              sobre alteracoes significativas por email ou atraves da plataforma. O uso continuado da
              plataforma apos as alteracoes constitui aceitacao das mesmas.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">13. Contato</h2>
            <p>
              Em caso de duvidas sobre esta Politica de Privacidade ou sobre o tratamento de seus dados
              pessoais, entre em contato:<br />
              Email: suporte@sinticket.com.br
            </p>
          </section>

        </div>
      </div>
    </div>
  );
};

export default PoliticaPrivacidade;
